import * as DG from 'datagrok-api/dg';
export var TAGS;
(function (TAGS) {
    /** Controls displaying WebLogo in a Macromolecule column's header tooltip */
    TAGS["tooltipWebLogo"] = ".tooltipWebLogo";
})(TAGS || (TAGS = {}));
export var PositionHeight;
(function (PositionHeight) {
    PositionHeight["Entropy"] = "Entropy";
    PositionHeight["full"] = "100%";
})(PositionHeight || (PositionHeight = {}));
/** top, middle, bottom */
export var VerticalAlignments;
(function (VerticalAlignments) {
    VerticalAlignments["TOP"] = "top";
    VerticalAlignments["MIDDLE"] = "middle";
    VerticalAlignments["BOTTOM"] = "bottom";
})(VerticalAlignments || (VerticalAlignments = {}));
/** left, center, right */
export var HorizontalAlignments;
(function (HorizontalAlignments) {
    HorizontalAlignments["LEFT"] = "left";
    HorizontalAlignments["CENTER"] = "center";
    HorizontalAlignments["RIGHT"] = "right";
})(HorizontalAlignments || (HorizontalAlignments = {}));
export var PositionMarginStates;
(function (PositionMarginStates) {
    PositionMarginStates["AUTO"] = "auto";
    PositionMarginStates["ON"] = "on";
    PositionMarginStates["OFF"] = "off";
})(PositionMarginStates || (PositionMarginStates = {}));
/** The source for filtering sequences considered to plot WebLogo  */
export var FilterSources;
(function (FilterSources) {
    /** Sequences of filtered rows are considered, default. */
    FilterSources["Filtered"] = "Filtered";
    /** Sequences in selection are considered to plot WebLogo for faster exploration.
     * In case selection is empty displays all.
     */
    FilterSources["Selected"] = "Selected";
})(FilterSources || (FilterSources = {}));
export const WebLogoPropsDefault = new class {
    constructor() {
        // -- Data --
        this.sequenceColumnName = null;
        /** Aggregation function for values of {@link valueColumnName} */
        this.valueAggrType = DG.AGG.TOTAL_COUNT;
        /** Column name for values */
        this.valueColumnName = 'Activity';
        this.startPositionName = null;
        this.endPositionName = null;
        this.skipEmptySequences = true;
        this.skipEmptyPositions = false;
        this.shrinkEmptyTail = true;
        // -- Style --
        this.backgroundColor = 0xFFFFFFFF;
        this.positionHeight = PositionHeight.Entropy; // that is the way in the bioinformatics domain
        this.positionWidth = 20;
        // -- Layout --
        this.verticalAlignment = VerticalAlignments.MIDDLE;
        this.horizontalAlignment = HorizontalAlignments.CENTER;
        this.fixWidth = false;
        this.fitArea = true;
        this.minHeight = 25;
        this.maxHeight = 300;
        this.maxMonomerLetters = 5;
        this.showPositionLabels = true;
        this.positionMarginState = PositionMarginStates.AUTO;
        this.positionMargin = 0;
        // -- Behavior --
        this.filterSource = FilterSources.Filtered;
    }
}();
export const positionRe = /(\d+)([A-Z]?)/;
//# sourceMappingURL=web-logo.js.map